module.exports = __webpack_public_path__ + "home-stack-logos.N4HdBNoQ.svg";